import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumbs = () => {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter((x) => x);

    if (pathnames.length === 0) return null;

    // Map pathnames to breadcrumb labels
    const breadcrumbMap = {
        'propiedades': 'Centro Inmobiliario',
        'nosotros': 'Quiénes Somos',
        'contacto': 'Contacto',
        'planes': 'Planes',
        'subscription': 'Suscripciones',
        'centro-financiero': 'Herramientas',
        'servicios': 'Servicios',
        'blog': 'Blog',
        'favoritos': 'Favoritos',
        'comparar': 'Comparar',
        'alertas': 'Alertas',
        'agente': 'Agente',
        'propiedad': 'Propiedad',
        'catalogo': 'Catálogo',
    };

    return (
        <nav className="bg-gray-50 border-b border-gray-200 py-3 mb-6">
            <div className="container mx-auto px-4">
                <ol className="flex items-center space-x-2 text-sm text-gray-500 overflow-x-auto whitespace-nowrap">
                    <li>
                        <Link to="/" className="flex items-center hover:text-blue-600 transition-colors">
                            <Home size={14} className="mr-1" />
                            <span>Inicio</span>
                        </Link>
                    </li>
                    {pathnames.map((value, index) => {
                        const last = index === pathnames.length - 1;
                        const to = `/${pathnames.slice(0, index + 1).join('/')}`;
                        const label = breadcrumbMap[value] || value.charAt(0).toUpperCase() + value.slice(1);

                        return (
                            <li key={to} className="flex items-center space-x-2">
                                <ChevronRight size={14} className="text-gray-400" />
                                {last ? (
                                    <span className="font-semibold text-blue-600 truncate max-w-[200px]">{label}</span>
                                ) : (
                                    <Link to={to} className="hover:text-blue-600 transition-colors">
                                        {label}
                                    </Link>
                                )}
                            </li>
                        );
                    })}
                </ol>
            </div>
        </nav>
    );
};

export default Breadcrumbs;
